import React from 'react'
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import { useState, useMemo, } from "react";
import { useNavigate } from "react-router-dom";
import ClinicUserModal from './ClinicModal/ClinicUserModal';
import Form from 'react-bootstrap/Form';
import CustomHeader from './CustomHeader';


function ClinicUsers() {





    const tableStyle = `
       .ag-full-width-container{
  height : 100% !important;
}


// @media only screen and (min-width:1880px) {
//     .ag-body-horizontal-scroll{
//         display: none;
//     }
// }


.ag-header-cell-text {
font-size: 0.9rem;
text-transform: uppercase;
color: #1e374f;
font-weight: 600;
font-family: var(--ct-font-Public-Sans);
}

    .ag-header-cell-resize::after{
            background-color: #1991eb52;
        }


  .ag-theme-quartz{
  padding: 0.4rem;
  }

    .ag-ltr .ag-cell{

            text-align: center;
            display: flex;
            // justify-content: center;
            align-items: center;
    }

    .ag-header{
        // background-color: #edeff6;
         border: none;
        padding: 0.5rem 0;

        min-height: 48px !important;
    }

    .ag-row {
     border: 1px solid #eeedf0;

    }

        .ag-row-odd {
background-color: #f7f7f7 !important; /* Light gray */
}


    .ag-cell{
border-left: 1px solid #eeedf0 !important;
}



    .ag-root-wrapper{
      border: unset;
      background: transparent
    }

    .ag-body-viewport{
      border: 1px solid #8080801a;
      border-top-left-radius: 5px !important;
      border-top-right-radius: 5px !important;
      background-color: white;
    }

    .ag-theme-quartz .ag-header-cell-filter-button{
    display: none;}

.ag-ltr .ag-header-cell-resize{
    }

     .ag-cell, .ag-cell-not-inline-editing, .ag-cell-normal-height, .ag-cell-value, .ag-cell-focus{
        font-size: .9rem;
     }

.ag-body-vertical-scroll{
  display : none;
}

.ag-header-cell-sortable .ag-header-cell-label{
 justify-content: start;
}

.ag-ltr .ag-cell {
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  color: #3584cdcc !important;
}


.odd-row {
background-color: #f8f8fc;
}

.span-saceuu7u7{
  font-size: 13px; 
  background-color: #FAAB3C; 
  padding: .8rem .5rem;
  border-radius: 10rem;
  height:1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.span-jkmkmkmkm{
  font-size: 10px; 
  color: #6941C6 ;
  border: solid .1px #6941C6; 
  background-color: #F9F5FF; 
  padding: .8rem .5rem;
  border-radius: 10rem;
  width: 7rem;
  height:1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.span-jkmkmkmkmjbui{
  font-size: 10px; 
  color: #175CD3 ;
  border: solid .1px #B2DDFF; 
  background-color: #EFF8FF; 
  padding: .8rem .5rem;
  border-radius: 10rem;
  width: 7rem;
  height:1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ag-header-cell-label{
display: flex;
justify-content: center;
}

 .ag-body-horizontal-scroll{
                height: 5px !important;
            max-height: 5px !important;
            min-height: 5px !important;
             }
        
             .ag-body-horizontal-scroll-viewport{
                height: 5px !important;
            max-height: 5px !important;
            min-height: 5px !important;
             }

 .ag-root ::-webkit-scrollbar-track
        {
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
            background-color: #F5F5F5;
        }
        
        .ag-root ::-webkit-scrollbar
        {
            width: 5px;
            background-color: #F5F5F5;
        }
        
        .ag-root ::-webkit-scrollbar-thumb
        {
            background-color: #80808070;
        }
        
        .ag-root ::-webkit-scrollbar-button {
            width: 0px;
            height: 0px;
            visibility: hidden;
        } `;

    const [paginationPageSize, setPaginationPageSize] = useState(20);

    const autoSizeStrategy = {
        type: "fitCellContents",
        columnLimits: [
            {
                colId: "No of Team Members",
                minWidth: 900,
            },
        ],
    };

    const defaultColDef = useMemo(() => {
        return {
            flex: 1,
            filter: true,
            headerComponent: CustomHeader,
        };
    }, []);

    const rowSelection = {
        mode: "multiRow",
        headerCheckbox: true,
    };


    const [rowData, setRowData] = useState([
        
        {
            Name: "Ina Hogan",
            ListUsers: "Admin",
            CreateDate: "24 Otc, 2015",
            Role: "Hospital Administrator",
            Action: "",
        },

        {
            Name: "Devin Harmon",
            ListUsers: "Admin",
            CreateDate: "18 Dec, 2015",
            Role: "IT Administrator",
            Action: "",
        },

        {
            Name: "Lena Page",
            ListUsers: "Employee",
            CreateDate: "8 Otc, 2016",
            Role: "Lab Technicians",
            Action: "",
        },

        {
            Name: "Eula Horton",
            ListUsers: "Super Admin",
            CreateDate: "15 Jun, 2017",
            Role: "Receptionist",
            Action: "",
        },

        {
            Name: "Victoria Perez",
            ListUsers: "HR Admin",
            CreateDate: "12 Jan, 2019",
            Role: "HR",
            Action: "",
        },


    ]);

    const [colDefs, setColDef] = useState([

        {
            headerName: "Name",
            field: "Name",
            minWidth: 200,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
              
                return (
                    <>
                        <div className="d-flex flex-column">

                            <span
                                className="fw-semibold m-0"
                                style={{fontSize: "14px", color: "#646262",fontWeight:600}}
                            >
                                {params.value}
                            </span>

                            {/* <span
                                className="fw-semibold m-0"
                                style={{ fontSize: "11px", color: "#8F9BB3" }}
                            >
                                {params.value}
                            </span> */}
                        </div>

                    </>
                );
            },
        },

        {
            field: "ListUsers",
            headerName: "List Users",
            minWidth: 200,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
             
                return (
                    <>
                        {params.value === "Admin" && (
                            <span
                                className="fw-semibold m-0 rounded-2"
                                style={{
                                    fontSize: "13px",
                                    color: "#fff",
                                    background: "#0095FF",
                                    width: "7rem",
                                    height: "2rem",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                {params.value}
                            </span>
                        )}

                        {params.value === "Super Admin" && (
                            <span
                                className="fw-semibold m-0 rounded-2"
                                style={{
                                    fontSize: "13px",
                                    color: "#fff",
                                    background: "#0095FF",
                                    width: "7rem",
                                    height: "2rem",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                {params.value}
                            </span>
                        )}

                        {params.value === "Employee" && (
                            <span
                                className="fw-semibold m-0 rounded-2"
                                style={{
                                    fontSize: "13px",
                                    color: "#000",
                                    background: "#D6D6D6",
                                    width: "7rem",
                                    height: "2rem",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                {params.value}
                            </span>
                        )}

                        {params.value === "HR Admin" && (
                            <span
                                className="fw-semibold m-0 rounded-2"
                                style={{
                                    fontSize: "13px",
                                    color: "#fff",
                                    background: "#0095FF",
                                    width: "7rem",
                                    height: "2rem",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                {params.value}
                            </span>
                        )}

                    </>
                );
            },
        },

        {
            field: "CreateDate",
            headerName: "Create Date",
            minWidth: 200,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
              
                return (
                    <>
                        <span
                            className="fw-semibold m-0"
                            style={{fontSize: "14px", color: "#646262",fontWeight:600}}
                        >
                            {params.value}
                        </span>
                    </>
                );
            },
        },

        {
            field: "Role",
            headerName: "Role",
            minWidth: 200,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
             
                return (
                    <>
                        <span
                            className="fw-semibold m-0"
                            style={{fontSize: "14px", color: "#646262",fontWeight:600}}
                        >
                            {params.value}
                        </span>
                    </>
                );
            },
        },

        {
            field: "Seeing",
            headerName: "Action",
            suppressSizeToFit: true,
            cellRenderer: function (params) {
            
                return (
                    <>
                        <div className="d-flex align-items-center justify-content-start gap-3">
                            <button
                                style={{ border: "none", background: "none", color: "#035ECF" }}
                            >
                                <i class="fa-regular fa-pen-to-square"></i>
                            </button>

                            <Form>
                                <Form.Check
                                    style={{ marginBottom: "-22px" }}
                                    type="switch"
                                    id="custom-switch"
                                />
                            </Form>
                        </div>
                    </>
                );
            },
        },
    ]);

    return (
        <>
            <style>{tableStyle}</style>
            <main style={{ width: "100%", height: '100%' }}>
                <div className="row">
                    <div className="col-12 mb-3">
                        <div className="d-flex align-items-center justify-content-end gap-3">
                            <ClinicUserModal />

                            <Form.Select aria-label="Default select example" className='form-jeue'>
                                <option value="1">Sort by</option>
                                <option value="2">One</option>
                                <option value="3">Two</option>
                                <option value="4">Three</option>
                            </Form.Select>

                            <Form.Select aria-label="Default select example" className='form-jeuveve' >
                                <option value="1">Saved search</option>
                                <option value="2">One</option>
                                <option value="3">Two</option>
                                <option value="4">Three</option>
                            </Form.Select>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className='ag-theme-quartz'
                            style={{
                                height: "454",
                                boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                                backgroundColor: "#fff",
                                minHeight: "43rem",
                                borderRadius: "12px",
                            }} // the Data Grid will fill the size of the parent container
                        >
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={colDefs}
                                defaultColDef={defaultColDef}
                                pagination={false}
                                domLayout="autoHeight"
                                rowClass={"tbl-row-sc"}
                                rowHeight={60}
                                autoSizeStrategy={autoSizeStrategy}
                                paginationPageSize={paginationPageSize}
                                rowSelection={rowSelection}
                            />
                        </div>
                    </div>
                </div>
            </main>


        </>
    )
}

export default ClinicUsers